var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17.6320962px",
    height: "18.1030101px",
    viewBox: "0 0 17.6320962 18.1030101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5FF49EB6-11F4-4A88-BB1C-53DB8B326936") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prospecting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loan-Trackers--Leads",
    transform: "translate(-1372.521, -121)",
    fill: "#A28014"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1372.52099,121 L1379.98342,121 L1379.98342,128.462434 L1372.52099,128.462434 Z M1382.69065,121 L1390.15308,121 L1390.15308,128.462434 L1382.69065,128.462434 Z M1372.52099,131.640576 L1379.98342,131.640576 L1379.98342,139.10301 L1372.52099,139.10301 Z M1382.69065,131.640576 L1390.15308,131.640576 L1390.15308,139.10301 L1382.69065,139.10301 Z",
    id: "Tile-View"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridView);
export default __webpack_public_path__ + "static/media/grid-view.da5b6e2f229a241ff7f8fd40425d24bc.svg";
export { ForwardRef as ReactComponent };